import React, { useEffect, useState } from "react";
import Layout from "./../../components/Layout/Layout";
import AdminMenu from "./../../components/Layout/AdminMenu";
import toast from "react-hot-toast";
import axios from "axios";
import CategoryForm from "../../components/Form/CategoryForm";
import "../../styles/Admin-User-panel.css"
import { Modal } from "antd";
import Swal from "sweetalert2";
const CreateCategory = () => {
  const [categories, setCategories] = useState([]);
  const [name, setName] = useState("");
  const [visible, setVisible] = useState(false);
  const [selected, setSelected] = useState(null);
  const [updatedName, setUpdatedName] = useState("");
  const [value,setValue]=useState("");

  //handle Form
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const { data } = await axios.post(`https://avon.onrender.com/api/v1/category/create-category`, {
        name,
      });
      if (data?.success) {
        toast.success(`${name} is created`);
        getAllCategory();
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.log(error);
      // toast.error("somthing went wrong in input form");
    }
  };


  //get all cat
  const getAllCategory = async () => {
    try {
      const { data } = await axios.get(`https://avon.onrender.com/api/v1/category/get-category`);
      if (data?.success) {
        setCategories(data?.category);
      }
    } catch (error) {
      console.log(error);
      toast.error("Something wwent wrong in getting catgeory");
    }
  };

  useEffect(() => {
    getAllCategory();
  }, []);

  useEffect(() => {
    getAllCategory();
  }, [categories]);

  //update category
  const handleUpdate = async (e) => {
    e.preventDefault();
    try {
      const { data } = await axios.put(
        `https://avon.onrender.com/api/v1/category/update-category/${selected._id}`,
        { name: updatedName }
      );
      if (data?.success) {
        toast.success(`${updatedName} is updated`);
        setSelected(null);
        setUpdatedName("");
        setVisible(false);
        getAllCategory();
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.log(error);
    }
  };
  //delete category
  const handleDelete = async (pId) => {
    const result = await Swal.fire({
      icon: 'warning',
      title: `Are you sure you want to delete This product?`,
      showCancelButton: true,
      confirmButtonText: 'Delete',
      cancelButtonText: 'Cancel',
      reverseButtons: true
    });
    try {
      if (result.isConfirmed){
    const { data } = await axios.delete(
      `https://avon.onrender.com/api/v1/category/delete-category/${pId}`
    );  
    if (data.success) {
      toast.success(`category is deleted`);

      getAllCategory();
    } else {
      toast.error(data.message);
    }
  }} catch (error) {
    toast.error("Somtihing went wrong");
  }
};
// //check if input empty
// const submitForm = (e) => {
//   e.preventDefault(); // prevent default form submission behavior
//   if (value.trim() !== "") { // check if input value is not empty
//     handleSubmit(); // call the provided handleSubmit function
//     setValue(""); // clear the input field after submission

// //   }

// };
  return (
    <Layout title={"Dashboard - Create Category"}>
      <div className="container-fluid m-3 p-3 dashboard">
        <div className="admin-dash">
          <div className="col-md-3">
            <AdminMenu />
          </div>
          <div className="col-category-pan">
            <h1>Manage Category</h1>
            <div className="p-3 w-50">
              <CategoryForm
                handleSubmit={handleSubmit}
                value={name}
                setValue={setName}
              />
            </div>
            <div className="cat-table">
              <table className="table-category">
                {/* <thead>
                  <tr>
                    <th scope="col">Name</th>
                    <th scope="col">Actions</th>
                  </tr>
                </thead> */}
                <tbody className="tbodycat">
                  {categories?.map((c) => (
                    <>
                      <div className="cat-editor">
                      <div className="cat-editor-info">
                        <div className="catnameinfo" key={c._id}>{c.name}</div>
                        <div className="catbtnedrm">
                          <button
                            className="btn-ms-2"
                            onClick={() => {
                              setVisible(true);
                              setUpdatedName(c.name);
                              setSelected(c);
                            }}
                          >
                            Edit
                          </button>
                          <button
                            className="btn-ms-3"
                            onClick={() => {
                              handleDelete(c._id);
                            }}
                          >
                            Delete
                          </button>
                        </div>
                        </div>
                      </div>
                    </>
                  ))}
                </tbody>
              </table>
            </div>
            <Modal
              onCancel={() => setVisible(false)}
              footer={null}
              visible={visible}
            >
              <CategoryForm
                value={updatedName}
                setValue={setUpdatedName}
                handleSubmit={handleUpdate}
              />
            </Modal>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default CreateCategory;